import { type Control, useWatch } from 'react-hook-form';
import { Button, CircularProgress } from '@mui/material';

import { PageHeader } from '@components/PageHeader';
import { type ProjectEditSchema } from '@/zod_schemas';

interface ProjectEditHeaderProps {
  control: Control<ProjectEditSchema>; // Use union type here
  isSubmitting: boolean;
}

const ProjectEditHeader = ({
  control,
  isSubmitting,
}: ProjectEditHeaderProps) => {
  const name = useWatch({
    control: control as Control<ProjectEditSchema>, // Use union type here
    name: 'name',
  });

  return (
    <PageHeader
      eyebrow="Project workspace"
      title={name || 'Project details'}
      description="Review the project information and manage its experiment groups."
      compact
      actions={
        <Button type="submit" variant="contained" disabled={isSubmitting}>
          {isSubmitting ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            'Save changes'
          )}
        </Button>
      }
    />
  );
};

export default ProjectEditHeader;
